const DEFAULT_ERROR = { description: 'Something Went Wrong', title: 'Error' };

// The root store only accepts `{ title, description }`; APIs sometimes send `errors: []` or omit it.
const toMessage = (errors, fallbackDescription) =>
    errors && typeof errors === 'object' && !Array.isArray(errors) && typeof errors.description === 'string'
        ? { ...errors, title: errors.title ?? DEFAULT_ERROR.title }
        : { ...DEFAULT_ERROR, description: fallbackDescription || DEFAULT_ERROR.description };

export const getErrorMessage = (error) => {
    const data = error?.response?.data;

    if (data) {
        return toMessage(data.errors, data.message);
    }

    if (error?.errors) {
        return toMessage(error.errors);
    }

    return DEFAULT_ERROR;
};
